// left here means an intersection of a left cone side with an obstacle edge
import { SweepEvent } from './SweepEvent';
export class LeftIntersectionEvent extends SweepEvent {
    get EndVertex() {
        return this.endVertex;
    }
    constructor(coneLeftSide, intersectionPoint, endVertex) {
        super();
        this.coneLeftSide = coneLeftSide;
        this.intersectionPoint = intersectionPoint;
        this.endVertex = endVertex;
    }
    get Site() {
        return this.intersectionPoint;
    }
    toString() {
        return 'LeftIntersectionEvent ' + this.intersectionPoint;
    }
}
//# sourceMappingURL=LeftIntersectionEvent.js.map